import { render, staticRenderFns } from "./ExportInsertPagesConfig.vue?vue&type=template&id=190ed77f"
import script from "./ExportInsertPagesConfig.vue?vue&type=script&lang=js"
export * from "./ExportInsertPagesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports